import { useTheme } from '@mui/material/styles';
import { getMultiAxisPlottingColors } from "../utils/chart"

const useDynamicChartColors = (count) => {
  const theme = useTheme();
  const baseColor = theme.palette.primary.main;
  const palette = getMultiAxisPlottingColors(count);
  return [baseColor, ...palette];
};

export default useDynamicChartColors;